import { render, staticRenderFns } from "./mobile_404.vue?vue&type=template&id=2bb1190c&scoped=true&"
import script from "./mobile_404.vue?vue&type=script&lang=js&"
export * from "./mobile_404.vue?vue&type=script&lang=js&"
import style0 from "./mobile_404.vue?vue&type=style&index=0&id=2bb1190c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1190c",
  null
  
)

export default component.exports